import React, { useRef, useState } from 'react';
import Layout from '../components/layout/Layout';
import SummaryWidget from '../components/summary/SummaryWidget';
import SummaryToolbar from '../components/summary/SummaryToolbar';
import DeviceTable from '../components/summary/DeviceTable';
import '../components/summary/Summary.css';
import '../components/analytics/Analytics.css';

// System start date (same as MonthRangePickerSummary)
const SYSTEM_START_YEAR = 2021;
const SYSTEM_START_MONTH = 1; // January

// Helper to format date as YYYY-MM
const formatYearMonth = (year, month) => {
  return `${year}-${String(month).padStart(2, '0')}`;
};

// Get default range: system start to current month
const getDefaultRange = () => {
  const now = new Date();
  return {
    from: formatYearMonth(SYSTEM_START_YEAR, SYSTEM_START_MONTH),
    to: formatYearMonth(now.getFullYear(), now.getMonth() + 1)
  };
};

export default function Summary() {
  const [query, setQuery] = useState('');
  const [dateRange, setDateRange] = useState(getDefaultRange); // Default: system start to now
  const deviceTableRef = useRef(null);

  return (
    <Layout>
      <div className="summary-page">
        {/* Row 1: session 1 + session 2 side by side */}
        <div className="sum-row">
          <section className="sum-section">
            <SummaryWidget dateRange={dateRange} />
          </section>
          <section className="sum-section session-toolbar">
            <SummaryToolbar
              value={query}
              onChange={setQuery}
              onFilterClick={() => deviceTableRef.current?.openFilterPopup()}
              dateRange={dateRange}
              onRangeChange={setDateRange}
            />
          </section>
        </div>

        {/* Row 2: session 3 full width */}
        <section className="sum-section sum-section--full">
          <DeviceTable 
            query={query} 
            ref={deviceTableRef} 
            dateRange={dateRange}
          />
        </section>
      </div>
    </Layout>
  );
}